export default __webpack_public_path__ + "static/media/NotMatched.532ce77b.svg";